import { store } from "common/store";

// All supported SSO providers
// Key is sso_provider from sso_provider in merchant.user
export const providers = {
    worldpay: {
        display_name: "Worldpay",
        supports_crud: true, // True if we can create, update, and delete users from Pazien app
        no_users_message: "This is because no users have signed in via their SSO service portal",
        // eslint-disable-next-line sentence-case/sentence-case
        user_management_button_caption: "Worldpay Service Portal",
        howToSignInText: "Your login was set up using Worldpay Service Portal"
    },
    disney: {
        display_name: "Disney",
        supports_crud: true,
        user_management_button_caption: "Disney",
        howToSignInText: "Your login was set up using MyID"
    },
    vap: {
        display_name: "Worldpay",
        supports_crud: false,
        user_management_button_caption: "iQ",
        howToSignInText: "Your login was set up using Worldpay iQ"
    },
    dsi_pazien: {
        display_name: "UK FIS",
        supports_crud: false,
        user_management_button_caption: "UK FIS",
        howToSignInText: "Multifactor authentication has been enabled for your account"
    },
    us_wp_pazien: {
        display_name: "US FIS",
        supports_crud: false,
        user_management_button_caption: "US FIS",
        howToSignInText: "Multifactor authentication has been enabled for your account"
    },
    fis_pazien: {
        // eslint-disable-next-line sentence-case/sentence-case
        display_name: "Ext Pazien",
        supports_crud: false,
        // eslint-disable-next-line sentence-case/sentence-case
        user_management_button_caption: "Ext Pazien",
        howToSignInText: "Multifactor authentication has been enabled for your account"
    }
};

export const providerSupportsSsoCrud = function(provider) {
    return Object.prototype.hasOwnProperty.call(providers, provider) && providers[provider].supports_crud;
};

export const providerAuthStep2Message = function(sso_provider) {
    const firstPart = providers[sso_provider]?.howToSignInText || "Your login was set up using SSO";
    return {
        howToSignInText: `${firstPart}. If redirect is not immediate`
    };
};

export const providerUserManagementName = function(provider) {
    const defaultButton = "SSO";
    if (Object.prototype.hasOwnProperty.call(providers, provider)) {
        return providers[provider]?.user_management_button_caption || defaultButton;
    }
    
    return defaultButton;
};

export const providerDisplayName = function(provider) {
    const defaultName = "SSO";
    if (Object.prototype.hasOwnProperty.call(providers, provider)) {
        return providers[provider]?.display_name || defaultName;
    }

    return defaultName;
};

export const getNoUsersMessage = function() {
    const state = store.getState();
    
    if (state.common.merchant_config.sso_providers?.includes("worldpay")) return providers.worldpay.no_users_message;
    
    return "Once users sign in through the network they will show here";
};
